import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
});

// Attach token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('gr_admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 -> redirect to login
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('gr_admin_token');
      if (window.location.pathname.startsWith('/admin') && window.location.pathname !== '/admin/login') {
        window.location.href = '/admin/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;

// Resolve an image URL for rendering.
// - Absolute http(s) URLs -> used as-is
// - Backend upload paths (/api/uploads/..) -> prefixed with backend base URL (works across domains)
// - Frontend public assets (/images/..) or anything else -> used as-is
export const resolveImg = (url) => {
  if (!url) return url;
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  if (url.startsWith('/api/')) return `${BACKEND_URL}${url}`;
  return url;
};

// Public content fetchers (no auth needed)
export const fetchNews = () => api.get('/news').then((r) => r.data);
export const fetchResults = () => api.get('/results').then((r) => r.data);
export const fetchGalas = () => api.get('/galas').then((r) => r.data);
export const fetchRegistration = () => api.get('/registration').then((r) => r.data);
export const fetchTeam = () => api.get('/team').then((r) => r.data);
export const fetchTrainingGroups = () => api.get('/training-groups').then((r) => r.data);
export const fetchTrainingLocations = () => api.get('/training-locations').then((r) => r.data);
export const fetchSiteConfig = () => api.get('/site-config').then((r) => r.data);
export const fetchPartners = () => api.get('/partners').then((r) => r.data);
export const fetchSiteImages = () => api.get('/site-images').then((r) => r.data);
